import React, { useState } from 'react';
import { postApi } from '../../services/apiService';
import UrlConfig from '../../data/UrlConfig';

// --- Iconos SVG ---
const SuccessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '12px', flexShrink: 0 }}>
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
    </svg>
);

const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '12px', flexShrink: 0 }}>
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
);

const NewsSender = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [sentEmails, setSentEmails] = useState([]);
    const [failedEmails, setFailedEmails] = useState([]);
    
    // --- Estado para la selección ---
    const [selectedOption, setSelectedOption] = useState('news');
    const [isHovered, setIsHovered] = useState(false);

    const handleSendNews = async () => {
        setIsLoading(true);
        setMessage('');
        setIsError(false);
        setSentEmails([]);
        setFailedEmails([]);

        try {
            const response = await postApi(UrlConfig.send_news, {
                code: selectedOption
            });
            
            setMessage(response.message || 'Proceso finalizado con éxito.');
            if (response.processedEmails) {
                setSentEmails(response.processedEmails.sent || []);
                setFailedEmails(response.processedEmails.failed || []);
            }
        } catch (error) {
            setMessage(`Error al enviar ${selectedOption}: ${error.message}`);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    const styles = {
        container: {
            backgroundColor: '#f8f9fa',
            padding: '40px',
            borderRadius: '12px',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
            maxWidth: '600px',
            margin: '40px auto',
            textAlign: 'center',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        },
        header: { color: '#343a40', marginBottom: '10px' },
        paragraph: { color: '#6c757d', marginBottom: '20px' },
        selectContainer: { marginBottom: '25px' },
        select: {
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid #ced4da',
            fontSize: '16px',
            width: '100%',
            maxWidth: '300px',
            cursor: 'pointer',
            backgroundColor: '#fff'
        },
        button: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease, transform 0.2s ease',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        buttonHover: { backgroundColor: '#0056b3', transform: 'scale(1.05)' },
        buttonDisabled: { backgroundColor: '#6c757d', cursor: 'not-allowed', opacity: 0.7 },
        messageContainer: {
            marginTop: '25px',
            padding: '20px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'flex-start',
            textAlign: 'left',
            fontWeight: '500',
        },
        successMessage: { backgroundColor: '#d4edda', color: '#155724' },
        errorMessage: { backgroundColor: '#f8d7da', color: '#721c24' },
        messageContent: { width: '100%' },
        listContainer: { marginTop: '15px', borderTop: '1px solid rgba(0, 0, 0, 0.1)', paddingTop: '10px' },
        listTitle: { fontWeight: 'bold', marginBottom: '5px', fontSize: '15px' },
        list: { listStyle: 'none', paddingLeft: '0', margin: '0', maxHeight: '150px', overflowY: 'auto' },
        listItem: { padding: '3px 0', fontSize: '14px', fontFamily: 'monospace' },
        listItemSuccess: { color: '#155724' },
        listItemError: { color: '#721c24' }
    };

    const buttonStyle = {
        ...styles.button,
        ...(isLoading ? styles.buttonDisabled : {}),
        ...(isHovered && !isLoading ? styles.buttonHover : {})
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.header}>Panel de Administrador</h2>
            <p style={styles.paragraph}>Selecciona el tipo de envío y presiona el botón.</p>
            
            <div style={styles.selectContainer}>
                <select 
                    style={styles.select} 
                    value={selectedOption} 
                    onChange={(e) => setSelectedOption(e.target.value)}
                    disabled={isLoading}
                >
                    <option value="news">Noticias (News)</option>
                    <option value="newsletter">Boletín (Newsletter)</option>
                </select>
            </div>

            <button
                onClick={handleSendNews}
                disabled={isLoading}
                style={buttonStyle}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {isLoading ? 'Enviando...' : `Enviar ${selectedOption === 'news' ? 'Noticias' : 'Newsletter'}`}
            </button>

            {message && (
                <div style={{ ...styles.messageContainer, ...(isError ? styles.errorMessage : styles.successMessage) }}>
                    {isError ? <ErrorIcon /> : <SuccessIcon />}
                    <div style={styles.messageContent}>
                        <span>{message}</span>

                        {!isError && (sentEmails.length > 0 || failedEmails.length > 0) && (
                            <div style={styles.listContainer}>
                                {sentEmails.length > 0 && (
                                    <div>
                                        <div style={styles.listTitle}>Enviados Correctamente:</div>
                                        <ul style={styles.list}>
                                            {sentEmails.map((email, index) => (
                                                <li key={`sent-${index}`} style={{...styles.listItem, ...styles.listItemSuccess}}>
                                                    {email}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {failedEmails.length > 0 && (
                                     <div style={{ marginTop: sentEmails.length > 0 ? '10px' : '0' }}>
                                        <div style={{...styles.listTitle, color: '#721c24'}}>Envíos Fallidos:</div>
                                        <ul style={styles.list}>
                                            {failedEmails.map((email, index) => (
                                                <li key={`failed-${index}`} style={{...styles.listItem, ...styles.listItemError}}>
                                                    {email}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsSender;